export const formatDate = (date: string): string => {
  if (!date) {
    return '';
  }

  return new Date(Date.parse(date))
    .toLocaleString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
    .slice(0, -' г.'.length);
};
